import { QueryParamName } from 'clerk_common/constants/urls/queryParams';
import { QUOTES_ROUTE } from 'clerk_common/constants/urls/routes';

export const getQuoteRoute = (webBaseUrl?: string, quoteId?: string) => {
  return `${webBaseUrl}${QUOTES_ROUTE}?${QueryParamName.QUOTE_ID}=${quoteId}`;
};
